<template>
	<div>
		<v-stepper v-model="e1">
			<v-stepper-header>
				<v-stepper-step editable :complete="e1 > 1" step="1">Employee Details</v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step :editable="isStep1Complete" step="2" :complete="e1 > 4">Login Details<small>Optional</small></v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step step="3" :editable="isStep1Complete">Assign Assets<small>Optional</small></v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step :editable="isStep1Complete" step="4">Summary</v-stepper-step>
			</v-stepper-header>

			<v-stepper-items>
				<v-stepper-content step="1">
					<employee-details-editor ref="employeeDetailsEditor" v-model="form.employeeDetails" :forms="employeeForms"></employee-details-editor>
					<v-btn color="primary" @click="step1Continue"> Continue </v-btn>
				</v-stepper-content>

				<v-stepper-content step="2">
					<v-layout row>
						<v-flex lg6>
							<create-employee-editor-login-editor class="mb-4" :loggedInEmployee="loggedInEmployee" :loginDetails="form.newEmployeeLoginDetails" @onUpdated="onUpdateNewEmployeeLoginDetails" />
						</v-flex>
					</v-layout>

					<v-btn flat @click="e1 = 1"><v-icon left>chevron_left</v-icon> Back</v-btn>
					<v-btn color="primary" @click="e1 = 3"> Continue </v-btn>
				</v-stepper-content>

				<v-stepper-content step="3">
					<v-card flat>
						<v-card-text class="text-xs-left">
							<p>Would you like to assign assets to this employee now? <small>(You can also do this later.)</small></p>
							<v-btn-toggle v-model="showAssetsSelection" mandatory>
								<v-btn flat>
									No
								</v-btn>
								<v-btn flat color="primary">
									Yes
								</v-btn>
							</v-btn-toggle>
						</v-card-text>
					</v-card>
					

					<assets-list v-if="showAssetsSelection" v-model="selectedAssets" flat hide-actions hide-assigned select-all openDetailInNewTab />

					<v-btn flat @click="e1 = 2"><v-icon left>chevron_left</v-icon> Back</v-btn>
					<v-btn color="primary" @click="e1 = 4"> Continue </v-btn>
				</v-stepper-content>

				<v-stepper-content step="4">
					<v-layout row>
						<v-flex>
							<h3 class="text-xs-left">Summary</h3>
						</v-flex>
						<v-flex shrink>
							<v-btn flat @click="e1 = 3"><v-icon left>chevron_left</v-icon> Back</v-btn>
							<v-btn @click="onCreateEmployeeClick" class="action-btn"> Create Employee </v-btn>
						</v-flex>
					</v-layout>

					<v-layout row v-if="isStep1Complete">
						<v-flex lg6>
							<v-card flat>
								<v-card-text>
									<v-list two-line>
										<v-list-tile inactive>
											<v-list-tile-action>
												<v-icon color="indigo">person</v-icon>
											</v-list-tile-action>

											<v-list-tile-content>
												<v-list-tile-title>{{ form.employeeDetails.basicInfo.firstName }} {{ form.employeeDetails.basicInfo.lastName }}</v-list-tile-title>
												<v-list-tile-sub-title>Full Name</v-list-tile-sub-title>
											</v-list-tile-content>
										</v-list-tile>

										<v-divider inset></v-divider>

										<v-list-tile inactive>
											<v-list-tile-action>
												<v-icon color="indigo">mdi-email-outline</v-icon>
											</v-list-tile-action>

											<v-list-tile-content>
												<v-list-tile-title>{{ form.employeeDetails.work.email }}</v-list-tile-title>
												<v-list-tile-sub-title>Email</v-list-tile-sub-title>
											</v-list-tile-content>
										</v-list-tile>

										<v-divider inset></v-divider>

										<v-list-tile inactive>
											<v-list-tile-action>
												<v-icon color="indigo">mdi-account-group-outline</v-icon>
											</v-list-tile-action>

											<v-list-tile-content>
												<v-list-tile-title>{{ form.employeeDetails.work.department.name }}</v-list-tile-title>
												<v-list-tile-sub-title>Department</v-list-tile-sub-title>
											</v-list-tile-content>
										</v-list-tile>
									</v-list>
								</v-card-text>
							</v-card>
						</v-flex>
						<v-flex lg6>
							<v-card flat>
								<v-card-text>
									<v-list>
										<v-list-tile inactive>
											<v-list-tile-action>
												<v-icon class="green--text" v-if="form.newEmployeeLoginDetails && form.newEmployeeLoginDetails.createLogin">mdi-check-circle-outline</v-icon>
												<v-icon class="grey--text" v-else>mdi-close-circle-outline</v-icon>
											</v-list-tile-action>

											<v-list-tile-content>
												<v-list-tile-sub-title v-if="form.newEmployeeLoginDetails && form.newEmployeeLoginDetails.createLogin">Create a Login</v-list-tile-sub-title>
												<v-list-tile-sub-title v-else>No Login will be created</v-list-tile-sub-title>
											</v-list-tile-content>
										</v-list-tile>

										<v-divider inset v-if="form.newEmployeeLoginDetails && form.newEmployeeLoginDetails.createLogin"></v-divider>

										<v-list-tile inactive v-if="form.newEmployeeLoginDetails && form.newEmployeeLoginDetails.createLogin">
											<v-list-tile-action>
												<v-icon class="green--text" v-if="form.newEmployeeLoginDetails.notifyEmployee">mdi-check-circle-outline</v-icon>
												<v-icon class="grey--text" v-else>mdi-close-circle-outline</v-icon>
											</v-list-tile-action>

											<v-list-tile-content>
												<v-list-tile-sub-title>Email login details to employee</v-list-tile-sub-title>
											</v-list-tile-content>
										</v-list-tile>

										<v-divider inset v-if="loggedInEmployee.isAdmin && form.newEmployeeLoginDetails && form.newEmployeeLoginDetails.createLogin"></v-divider>

										<v-list-tile inactive v-if="loggedInEmployee.isAdmin && form.newEmployeeLoginDetails && form.newEmployeeLoginDetails.createLogin">
											<v-list-tile-action>
												<v-icon class="green--text" v-if="form.newEmployeeLoginDetails.roles.includes('admin')">mdi-check-circle-outline</v-icon>
												<v-icon class="grey--text" v-else>mdi-close-circle-outline</v-icon>
											</v-list-tile-action>

											<v-list-tile-content>
												<v-list-tile-sub-title>Administrator privileges</v-list-tile-sub-title>
											</v-list-tile-content>
										</v-list-tile>

										<v-divider inset v-if="form.hideFromEmployeeDirectory"></v-divider>

										<v-list-tile inactive v-if="form.hideFromEmployeeDirectory">
											<v-list-tile-action>
												<v-icon class="green--text">mdi-check-circle-outline</v-icon>
											</v-list-tile-action>

											<v-list-tile-content>
												<v-list-tile-sub-title>Hide from Employee Directory</v-list-tile-sub-title>
											</v-list-tile-content>
										</v-list-tile>
									</v-list>

									<div v-if="form.employeeDetails.tags && form.employeeDetails.tags.length > 0" class="text-xs-left mt-3">
										<v-subheader class="pl-0"><v-icon class="mr-2">mdi-tag-multiple-outline</v-icon>Tags</v-subheader>
										<tag-items :tags="form.employeeDetails.tags" read-only />
									</div>
									<div class="mt-3 text-xs-left" v-if="hrPoliciesRelevant.length > 0">
										<v-subheader class="pl-0"><v-icon class="mr-2">mdi-file-document-outline</v-icon>HR Policies</v-subheader>
										<v-chip v-for="policy in hrPoliciesRelevant" :key="policy.id" small class="tag" color="info" dark>{{ policy.name }}</v-chip>
									</div>
									<div class="mt-3 text-xs-left" v-if="selectedAssets.length > 0">
										<v-subheader class="pl-0"><v-icon class="mr-2">mdi-clipboard-account-outline</v-icon>Assigned Assets</v-subheader>
										<v-chip v-for="asset in selectedAssets" :key="asset.id" small label>{{ asset.name }}</v-chip>
									</div>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>

		<confirmation-dialog v-if="showConfirmCreateDialog" :dialog="showConfirmCreateDialog" :isConfirming="isSaving" @onConfirm="createEmployee" @onCancel="showConfirmCreateDialog = false">
			<div class="pt-3 pb-2">
				Please confirm that you want to create employee: <strong>{{ form.employeeDetails.basicInfo.firstName }} {{ form.employeeDetails.basicInfo.lastName }}</strong>
			</div>
			<v-alert :value="true" color="info" icon="info" class="mt-4 text-xs-left caption" outline>Please note that adding a new employee may incur an extra cost, depending on your subscription. </v-alert>
		</confirmation-dialog>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { generatePassword } from '@/utils/generatePasswordUtil';

	import CreateEmployeeEditorLoginEditor from '@/components/employee/CreateEmployeeEditorLoginEditor';
	import TagItems from '@/components/tags/TagItems';
	import EmployeeHrDocumentSelector from '@/components/employee/EmployeeHrDocumentSelector';
	import EmployeeDetailsEditor from '@/components/employee/EmployeeDetailsEditor';
	import AssetsList from '@components/assets/AssetsList.vue';

	export default {
		components: {
			AssetsList,
			CreateEmployeeEditorLoginEditor,
			TagItems,
			EmployeeHrDocumentSelector,
			EmployeeDetailsEditor
		},
		data() {
			return {
				e1: 1,
				form: {
					id: null,
					status: 'active',
					positions: [],
					performanceReviews: [],
					isAdmin: false,
					goals: [],
					files: [],
					tags: [],
					hideFromEmployeeDirectory: false,
					newEmployeeLoginDetails: {
						createLogin: true,
						notifyEmployee: true,
						password: generatePassword(),
						roles: []
					},
					employeeDetails: {
						basicInfo: {
							firstName: null,
							lastName: null,
							middleName: null
						},
						work: {
							department: null,
							email: null,
							phone: null
						},
						personalDetails: {
							prefix: null,
							dateOfBirth: {
								date: null,
								menu: false
							},
							nationality: null,
							email: null,
							phone: null,
							gender: null
						},
						emergency: {
							firstName: null,
							lastName: null,
							email: null,
							phoneNo: null,
							relation: null
						},
						hrPolicies: [],
						tags: [],
						otherDetails: {
							hideFromEmployeeDirectory: false
						},
						login: {
							userId: null
						}
					}
				},
				showConfirmCreateDialog: false,
				isSaving: false,
				originalEmployeeSerialised: null,
				employeeDetailsSelectedTab: 0,
				right: null,
				isStep1Complete: false,
				selectedAssets: [],
				showAssetsSelection: 0
			};
		},
		created() {
			this.originalEmployeeSerialised = JSON.stringify(this.form);
		},
		watch: {
			isDirty(val) {
				this.$store.dispatch('employees/setDirtyEmployee', val);
			},
			showAssetsSelection(val) {
				if (!val) {
					this.selectedAssets = [];
				}
			}
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				loggedInTenant: 'loggedInTenant',
				hrPolicies: 'hrDocuments/hrPolicies',
				tagList: 'tags/employeeTagList'
			}),
			isDirty() {
				return JSON.stringify(this.form) !== this.originalEmployeeSerialised;
			},
			hrPoliciesFiltered() {
				return this.hrPolicies.map(x => {
					return {
						id: x.id,
						name: x.name,
						relevantParties: x.relevantParties
					};
				});
			},
			hrPoliciesRelevant() {
				return this.hrPoliciesFiltered.filter(x => x.relevantParties.all || this.form.employeeDetails.hrPolicies.includes(x.id));
			},
			employeeForms() {
				return [{ name: 'basicInfo', defaultState: 'edit' }, { name: 'work' }, { name: 'personal' }, { name: 'emergency' }, { name: 'tags' }, { name: 'hrPolicies' }, { name: 'otherDetails' }];
			}
		},
		methods: {
			onUpdateNewEmployeeLoginDetails(updated) {
				this.form.newEmployeeLoginDetails = updated;
			},
			onAddTag(newTagName) {
				this.form.tags.push({
					id: this.newGuid(),
					name: newTagName
				});
			},
			onRemoveTag(tagId) {
				const index = this.form.tags.findIndex(x => x.id === tagId);
				if (index > -1) {
					this.form.tags.splice(index, 1);
				}
			},
			step1Continue() {
				if (!this.validateStep1()) {
					return;
				} else {
					this.e1 = 2;
				}
			},
			validateStep1() {
				const validationResult = this.$refs.employeeDetailsEditor.validateAndSubmit();

				this.isStep1Complete = validationResult;

				return validationResult;
			},
			onCreateEmployeeClick() {
				this.showConfirmCreateDialog = true;
			},
			async createEmployee() {
				this.isSaving = true;
				let postObj = {
					id: this.form.id,
					firstName: this.form.employeeDetails.basicInfo.firstName,
					lastName: this.form.employeeDetails.basicInfo.lastName,
					middleName: this.form.employeeDetails.basicInfo.middleName,
					email: this.form.employeeDetails.work.email,
					positions: [],
					status: 'active',
					department: this.form.employeeDetails.work.department,
					hrPolicies: this.form.employeeDetails.hrPolicies,
					tags: this.form.employeeDetails.tags,
					hideFromEmployeeDirectory: this.form.employeeDetails.otherDetails.hideFromEmployeeDirectory,
					loginDetails: this.form.newEmployeeLoginDetails,
					personalDetails: {
						dateOfBirth: this.form.employeeDetails.personalDetails.dateOfBirth.date,
						nationality: this.form.employeeDetails.personalDetails.nationality,
						prefix: this.form.employeeDetails.personalDetails.prefix,
						email: this.form.employeeDetails.personalDetails.email,
						phone: this.form.employeeDetails.personalDetails.phone,
						gender: this.form.employeeDetails.personalDetails.gender
					},
					emergencyContactDetails: this.form.employeeDetails.emergency,
					workDetails: {
						phone: this.form.employeeDetails.work.phone
					}
				};

				this.isSaving = true;

				const result = await this.$store.dispatch('employees/addEmployee', postObj);

				if (result.isSuccess) {
					if (this.selectedAssets.length > 0) {
						await this.$store.dispatch('assets/assign', {
							assetIds: this.selectedAssets.map(asset => asset.id),
							employeeId: result.data.id,
							notes: 'Assigned as part of the onboarding workflow.'
						});
					}

					this.$store.dispatch('employees/setDirtyEmployee', false);
					this.$router.push({ name: 'employee', params: { id: result.data.id, previousAction: 'employee_created' } });
				}

				this.isSaving = false;
			}
		}
	};
</script>

<style scoped>
	.tag-desc {
		height: inherit;
		padding-left: 0;
	}
</style>
